// ---------------------- TEXT editor V2 -------------------------------------
import HELPER from '@/app/utils/HELPER';
import atom from '@/app/editor/iframe/atom';
import { trimDocumentFormat } from '@/app/utils/trimDocumentFormat';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import { app } from '@/store';
import { debounce } from '@modules/common';
import { handleElementAttrChanged } from '@/modules/gem-meter';

(function (jQuery) {
  jQuery.gfTextEditor = function (element, options) {
    const defaults = {};
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const _mdTextEditor =
      '<div id="md-text-editor"><ul><li><a href="#" class="gfButton" data-action="formatStyle" data-cmd="bold" data-toolTips="Bold"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M15,10.99c0.81-0.56,1.38-1.47,1.38-2.32c0-1.88-1.46-3.33-3.33-3.33H7.83V17h5.87 c1.74,0,3.09-1.42,3.09-3.16C16.79,12.57,16.08,11.49,15,10.99L15,10.99z M10.33,7.42h2.5c0.69,0,1.25,0.56,1.25,1.25 c0,0.69-0.56,1.25-1.25,1.25h-2.5V7.42L10.33,7.42z M13.25,14.92h-2.92v-2.5h2.92c0.69,0,1.25,0.56,1.25,1.25 S13.94,14.92,13.25,14.92L13.25,14.92z" /></svg></a></li><li><a href="#" class="gfButton" data-action="formatStyle" data-cmd="italic" data-toolTips="Italic"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M10.33,5.33v2.5h1.84L9.32,14.5H7V17h6.67v-2.5h-1.84l2.85-6.67H17v-2.5H10.33z" /></svg></a></li><li><a href="#" class="gfButton" data-action="formatStyle" data-cmd="underline" data-toolTips="Underline"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M12,16.17c2.76,0,5-2.24,5-5V4.5h-2.08v6.67c0,1.61-1.31,2.92-2.92,2.92s-2.92-1.31-2.92-2.92 V4.5H7v6.67C7,13.92,9.24,16.17,12,16.17L12,16.17z M6.17,17.83v1.67h11.67v-1.67H6.17L6.17,17.83z" /></svg></a></li><li><a href="#" data-action="formatLink" data-toolTips="Pick link"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M5.2,12c0-1.4,1.2-2.6,2.6-2.6h3.3V7.8H7.8c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2h3.3v-1.6 H7.8C6.4,14.6,5.2,13.4,5.2,12L5.2,12z M8.6,12.8h6.7v-1.7H8.6V12.8L8.6,12.8z M16.1,7.8h-3.3v1.6h3.3c1.4,0,2.6,1.2,2.6,2.6 s-1.2,2.6-2.6,2.6h-3.3v1.6h3.3c2.3,0,4.2-1.9,4.2-4.2S18.4,7.8,16.1,7.8L16.1,7.8z" /></svg></a></li><li><a href="#" data-action="formatColor" data-toolTips="Font color"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M11.58,4h1.67l4.58,11.67h-1.88l-0.93-2.5H9.81l-0.93,2.5H7L11.58,4z M10.43,11.5h3.97l-1.98-5.28 L10.43,11.5z" /><path d="M3,18h18v3H3V18z" class="colorActive" /></svg></a><div id="md-editor-color" class="md-editor-panel" ><div class="md-content"><div class="md-body"><div class="ui-dform-group" id="colorPicker-small"><div class="gfTextEditor-tabs"><span class="active" data-action="color">Text Color</span><span data-action="hightlight">Highlight Color</span></div><div class="gfTextEditor-tab tab_show" data-tab="color"><input type="text" name="color" data-alpha="true" data-hide="false" data-type="show" class="gryff-color" value="#333333" /></div><div class="gfTextEditor-tab" data-tab="hightlight"><input type="text" name="hightlight" data-alpha="true" data-hide="false" data-type="show" class="gryff-color" /></div></div></div></div></div></li><li><a href="#" data-action="plus" data-toolTips="Increase size"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M11,11V6h2v5h5v2h-5v5h-2v-5H6v-2H11z"/></svg></a></li><li><a href="#" data-action="minus" data-toolTips="Decrease size"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M6,11h12v2H6V11z"/></svg></a></li><li><a href="#" class="gfTextEditor_more" data-action="more" data-toolTips="Show more"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M10,7l5,5l-5,5V7z"/></svg></a></li><div class="more"><li><a href="#" class="formatList" data-cmd="insertOrderedList" data-action="formatList" data-toolTips="Numbers"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M9.68,18.02l1.94-1.67c0.9-0.78,1.21-1.07,1.21-1.58c0-0.47-0.21-0.69-1.02-0.69c-0.58,0-1.25,0.17-1.61,0.37 l-0.57-0.97c0.63-0.33,1.18-0.5,2.3-0.5c1.42,0,2.13,0.46,2.13,1.66c0,0.9-0.44,1.45-1.39,2.26l-1.22,1.06h2.68V19H9.68V18.02z M11.6,5.2h-1.01V4.08h2.24V10H11.6V5.2z"/></svg></a></li><li><a href="#" class="formatList" data-cmd="insertUnorderedList" data-action="formatList" data-toolTips="ul"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M12,14c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S10.9,14,12,14z M12,6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2 S10.9,6,12,6z"/></svg></a></li><li><a href="#" data-action="less" data-toolTips="Less"><svg class="need_a_name" height="24px" viewbox="0 0 24 24"><path d="M14,7l-5,5l5,5V7z"//></svg></a></li></div></ul></div>';
    const $editorToolLink = jQuery(
      '<div id="md-editor-link"> <div class="md-content"> <div class="md-body"> <div class="ui-dform-group"> <div class="gfTextEditor_pick_link"> <input type="text" placeholder="Eg: https://gem-buider.com" /> <div class="button-wrapper"><button type="button" data-action="enter"> <svg class="need_a_name" height="24px" viewbox="0 0 24 24"> <path d="M19.5,7C19.23,7,19,7.22,19,7.49V11H5.83l3.22-3.23c0.2-0.2,0.19-0.52,0-0.71l-0.7-0.7 c-0.2-0.2-0.52-0.2-0.71,0l-5.29,5.29c-0.2,0.2-0.2,0.52,0,0.71l5.29,5.29c0.2,0.2,0.52,0.2,0.71,0l0.7-0.7 c0.2-0.2,0.2-0.51,0-0.71L5.83,13H20.5c0.28,0,0.5-0.23,0.5-0.49V7.49C21,7.22,20.79,7,20.5,7H19.5z" /> </svg> </button> <button type="button" data-action="settings"> <svg class="need_a_name" height="24px" viewbox="0 0 24 24"> <path d="M19.88,7.65c0.33,0.6,0.59,1.24,0.78,1.89c0.07,0.26-0.07,0.53-0.32,0.61l-0.1,0.04 c-0.74,0.3-1.23,1.04-1.23,1.83c0,0.84,0.53,1.6,1.33,1.88c0.25,0.09,0.39,0.36,0.31,0.61c-0.19,0.66-0.46,1.29-0.79,1.89 c-0.13,0.23-0.41,0.32-0.65,0.21c-0.72-0.34-1.68-0.18-2.25,0.38c-0.59,0.58-0.75,1.49-0.4,2.24c0.11,0.24,0.02,0.52-0.21,0.65 c-0.29,0.16-0.59,0.3-0.89,0.43c-0.32,0.13-0.65,0.25-0.98,0.34c-0.25,0.07-0.52-0.07-0.61-0.32c-0.28-0.8-1.03-1.34-1.87-1.34 c-0.8,0-1.61,0.57-1.88,1.32c-0.09,0.25-0.36,0.39-0.61,0.31c-0.65-0.19-1.28-0.45-1.87-0.79c-0.23-0.13-0.32-0.41-0.21-0.65 c0.35-0.76,0.2-1.66-0.39-2.25c-0.59-0.59-1.47-0.75-2.18-0.43c-0.24,0.1-0.59,0.04-0.71-0.18c-0.33-0.6-0.59-1.24-0.78-1.89 c-0.07-0.25,0.04-0.51,0.31-0.61c0.81-0.34,1.34-1.07,1.34-1.87c0-0.84-0.53-1.6-1.32-1.88C3.42,10,3.28,9.73,3.36,9.48 c0.19-0.65,0.46-1.29,0.79-1.89C4.28,7.37,4.57,7.27,4.8,7.39C5.52,7.72,6.49,7.56,7.06,7c0.59-0.58,0.75-1.49,0.4-2.25 C7.35,4.52,7.44,4.24,7.67,4.11C8.27,3.78,8.9,3.52,9.55,3.34c0.26-0.07,0.52,0.07,0.61,0.32c0.28,0.8,1.03,1.34,1.87,1.34 c0.81,0,1.61-0.57,1.88-1.32c0.09-0.25,0.36-0.39,0.61-0.31c0.64,0.19,1.27,0.45,1.87,0.78c0.23,0.13,0.32,0.41,0.21,0.65 c-0.35,0.76-0.2,1.66,0.39,2.25c0.57,0.57,1.43,0.74,2.19,0.43C19.41,7.37,19.76,7.43,19.88,7.65z M13.15,14.77 c1.53-0.63,2.26-2.39,1.62-3.92c-0.63-1.53-2.39-2.26-3.92-1.62c-1.53,0.63-2.26,2.39-1.62,3.92C9.86,14.68,11.62,15.4,13.15,14.77z " /> </svg> </button></div> </div> </div> </div> </div> </div>',
    );
    const $quickLink = jQuery(
      '<div id="md-editor-quick-link"> <span>Edit or remove link:</span> <span class="edit-link">Edit</span> <span>-</span> <span class="remove-link">Unlink</span> <span>-</span> <span class="cancel-link">Cancel</span> </div>',
    );

    const _saveSelection = {
      start: 0,
      end: 0,
    };

    const _isTyping = false;
    let _isEditing = false;
    let _isEditLink = false;

    let _cacheID = '';
    let _cacheContent = null;

    let _textEditorTimeout;

    let $editorTool;
    let $activeElement;

    /* Editor */
    const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
    const $gfResTool = jQuery('#gfResTool');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      _this.initEditor();
      _this.applyEvents();

      return false;
    };
    this.initEditor = function () {
      if ($gryffBody.find('#md-text-tool').length == 0) {
        $editorTool = jQuery(_mdTextEditor).appendTo($divContentHidden);
      }
      return false;
    };

    this.showEditor = function ($target) {
      const linkedPresetId = app.$store.state['sidebar']['linkedPresetId'];
      const hasCustomClass = $target.find('.gf_gs_ct');
      const $li = $editorTool.find('ul li');
      const plus = $li.find('[data-action="plus"]');
      const minus = $li.find('[data-action="minus"]');
      const minusSvg = minus.find('svg');
      const plusSvg = plus.find('svg');

      if (linkedPresetId > 0 && hasCustomClass.length <= 0) {
        // off hover
        minus.attr('disabled', true).attr('data-tooltips', '');
        plus.attr('disabled', true).attr('data-tooltips', '');

        // change color svg
        minusSvg.addClass('fill-dark-disabled');
        plusSvg.addClass('fill-dark-disabled');
      } else {
        minus.removeAttr('disabled').attr('data-tooltips', 'Decrease size');
        plus.removeAttr('disabled').attr('data-tooltips', 'Increase size');

        minusSvg.removeClass('fill-dark-disabled');
        plusSvg.removeClass('fill-dark-disabled');
      }

      if ($editorTool != undefined && $target != undefined) {
        _isEditing = true;

        // Hide tools all;
        const $mer = $gfLeftSideBar.children('.gf_row, .module-wrap, .element-wrap');
        if ($mer) {
          if ($mer.data('gfrow') != undefined) {
            $mer.data('gfrow').hideTool();
          } else if ($mer.data('gfmodule') != undefined) {
            $mer.data('gfmodule').hideTool();
          } else if ($mer.data('gfelement') != undefined) {
            $mer.data('gfelement').hideTool();
          }
        }

        // setup buttons
        if ($editorTool != undefined) {
          $editorTool.find('a').removeClass('active');
          $editorTool.find('.md-editor-panel').removeClass('active');
        }

        $gryffBody.find('.text-edit').removeClass('text-editing');

        $target.find('.text-edit').addClass('text-editing').attr('contenteditable', true);

        if ($activeElement != undefined) {
          $activeElement
            .find('.text-editing')
            .off('mousedown.selectText')
            .on('mousedown.selectText', function (e) {
              clearTimeout(_textEditorTimeout);

              $gryffBody.off('mouseup.selectText').on('mouseup.selectText', function (e) {
                _textEditorTimeout = setTimeout(function () {
                  const $target = jQuery(e.target);
                  if ($target.closest('[data-label="Text Block"], [data-label="Heading"]').length == 0) {
                    _this.saveSelection();
                    _this.showEditor($activeElement);
                  }
                }, 10);

                $gryffBody.off('mouseup.selectText');
              });
            });

          $activeElement
            .find('.text-editing')
            .off('mouseup.selectText')
            .on('mouseup.selectText', function () {
              _this.saveSelection();
              $gryffBody.off('mouseup.selectText');
            });
        }

        // PASTE AS PLAIN TEXT
        $target.off('paste.editor').on('paste.editor', function (e) {
          e.preventDefault();
          const clipboard = {
            text: e.originalEvent.clipboardData.getData('text'),
            html: e.originalEvent.clipboardData.getData('text/html'),
          };

          /**
           * Paste data from clipboard into text block.
           * There's two type of data to be inserted: DOMContent and Plain text
           * @param {Boolean} asHTML is the data to be inserted HTML?
           */
          const pasteData = (asHTML = false) => {
            // Handle for plain text inserting
            if (!asHTML) {
              const pastedData = clipboard.text;
              document.getElementById('gfFrame').contentWindow.document.execCommand('insertText', false, pastedData);
            } else {
              const pastedData = clipboard.html;
              if (checkKeyValid('trimDocumentFormat')) {
                const trimmedData = trimDocumentFormat(pastedData);
                document.getElementById('gfFrame').contentWindow.document.execCommand('insertHTML', false, trimmedData);
              } else {
                document.getElementById('gfFrame').contentWindow.document.execCommand('insertHTML', false, pastedData);
              }
            }

            // Trigger change to update data into divContentBk
            HELPER.flagListItemChange($target, 'replace');

            const $itemContent = $target.closest('.item-content');
            HELPER.detectContentChange($itemContent);
          };

          let keyBoardCtrl = `Ctrl`;
          if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
            keyBoardCtrl = `<span class="icon-macos"></span>`;
          }

          const MODAL_ID = 'md-confirm-paste';
          const config = {
            header: 'Please Confirm',
            footer: 'footer',
            width: 600,
            center: true,
            saveLabel: 'Yes',
            cancelLabel: 'No, keep source formatting',
            overlayClick: false,
            onContent: function ($content) {
              const content =
                '<h3>Would you like to paste plain text?</h3>' +
                `<p>To quickly paste plain text next time, press <span class="keyboard">${keyBoardCtrl}</span> <span class="plus">+</span> <span class="keyboard">Shift</span> <span class="plus">+</span> <span class="keyboard">V</span></p> `;
              $content.html(content);
            },
            onCancel: function () {
              pasteData(true);
              $('#' + MODAL_ID)
                .data('gfmodalnew')
                .onClose();
            },
            onSave: function () {
              pasteData(false);
              $('#' + MODAL_ID)
                .data('gfmodalnew')
                .onClose();
            },
            onSave: function () {
              pasteData(false);
              $('#' + MODAL_ID)
                .data('gfmodalnew')
                .onClose();
            },
            onClose: function () {
              // Remove modal when close
              $('#' + MODAL_ID).remove();
            },
          };

          // Paste plain text if paste target is not `Text Block`
          if ($activeElement.attr('data-label') != 'Text Block') {
            pasteData(false);
            return;
          }

          // If there's no html content, just paste plain text
          if (clipboard.html.length == 0) {
            // Should not paste when there's no text copied
            if (clipboard.text.length == 0) return;

            pasteData(false);
            return;
          }

          let $modal;
          // Init modal if not exist, otherwise assign it to variable $modal
          if ($divContentHidden.find('#' + MODAL_ID).length < 1) {
            $modal = jQuery(`<div id="${MODAL_ID}" />`);
            $divContentHidden.append($modal);
            $modal.gfModalNew(config);
          } else {
            // chỗ này hơi thừa nhưng cứ để lại cho chắc ....
            $modal = $divContentHidden.find('#' + MODAL_ID);
            if (!$modal.data('gfmodalnew')) {
              $modal.gfModalNew(config);
            }
          }
          // open modal
          $modal.data('gfmodalnew').onShow();
        });

        const node = _this.getSelectedNode();
        if (node != undefined) {
          const $node = jQuery(node);
          if ($node.css('fontWeight') == 700) {
            $editorTool.find('a[data-cmd="bold"]').addClass('active');
          }
          if ($node.css('fontStyle') == 'italic') {
            $editorTool.find('a[data-cmd="italic"]').addClass('active');
          }
          if ($node.css('textDecoration').indexOf('underline') >= 0) {
            $editorTool.find('a[data-cmd="underline"]').addClass('active');
          }
          if ($node.closest('ul').length > 0) {
            $editorTool.find('a[data-cmd="insertUnorderedList"]').addClass('active');
          }
          if ($node.closest('ol').length > 0) {
            $editorTool.find('a[data-cmd="insertOrderedList"]').addClass('active');
          }
          if ($node.closest('a').length > 0) {
            $editorTool.find('a[data-action="formatLink"]').addClass('active');
          }
          if ($node.length > 0) {
            const _color = $node.css('color');
            const $color = $editorTool.find('a[data-action="formatColor"]');
            $color.find('.colorActive').css({
              fill: _color,
            });
          }
        }

        if (!$editorTool.hasClass('show') || _cacheID !== $activeElement.attr('id')) {
          if ($activeElement) {
            _cacheID = $activeElement.attr('id');
          }

          _this.hideEditorLink();
          _this.hideQuickLink();

          _this.eventLink();

          const targetWidth = $target.width();
          const editorHeight = $editorTool.height();
          const editorWidth = $editorTool.width();

          const fST = $gfFrame.contents().scrollTop();
          const fL = $gfFrame.offset().left;
          const fT = $gfFrame.offset().top;

          const offset = $target.find('.text-editing').offset();

          let left = offset.left + fL + targetWidth / 2 - editorWidth / 2;
          let top = offset.top + fT - fST - editorHeight - 8;

          if (left < 0) {
            left = 0;
          }

          left = left * window._zoomOut;
          top = top * window._zoomOut;
          if (top < editorHeight + 8) {
            top = 110; // Text holder element at the top of the page
          }

          $editorTool
            .css({
              left: left,
              top: top,
            })
            .addClass('show');

          const _iframeContent = $gfFrame.contents();
          $(_iframeContent)
            .off('scroll.tool')
            .on('scroll.tool', function (e) {
              if ($gryffBody.find('.text-editing').length > 0) {
                const _offset = $gryffBody.find('.text-editing').offset();
                const _topScroll = _iframeContent.scrollTop();
                if (_topScroll > top + fST) {
                  $editorTool.css({
                    left: left,
                    top: 60,
                  });
                } else {
                  const _top = (_offset.top + fT - editorHeight - _topScroll - 8) * window._zoomOut;
                  $editorTool.css({
                    left: left,
                    top: _top,
                  });
                }
              }
            });
        }

        // hide tool
        if ($target.data('gfelement') != undefined) {
          $target.data('gfelement').hideTool();
          $target.parents('.gf_row, .module-wrap').each(function () {
            if (jQuery(this).data('gfrow') != undefined) {
              jQuery(this).data('gfrow').hideTool();
            } else if (jQuery(this).data('gfmodule') != undefined) {
              jQuery(this).data('gfmodule').hideTool();
            }
          });
        }
      }
    };

    this.eventLink = function () {
      // Tool Link
      if ($divContentHidden.find('#md-editor-quick-link').length == 0) {
        $divContentHidden.append($quickLink);
      }
      if ($divContentHidden.find('#md-editor-quick-link').length > 0) {
        if ($activeElement) {
          $activeElement
            .find('.text-editing a')
            .off('click.quickLink')
            .on('click.quickLink', function (e) {
              const $target = jQuery(e.target);
              if ($target.closest('[data-label="Text Block"], [data-label="Heading"]').length > 0) {
                $activeElement = $target.closest('[data-label="Text Block"], [data-label="Heading"]');
                _this.showEditor($activeElement);
              }

              const $that = $(this);
              $activeElement.find('.text-editing a').removeClass('editor_link_selection');
              $that.addClass('editor_link_selection');

              const targetWidth = $that.outerWidth();
              const targetHeight = $that.outerHeight();
              const editorHeight = $quickLink.outerHeight();
              const editorWidth = $quickLink.outerWidth();

              const fST = $gfFrame.contents().scrollTop();
              const fL = $gfFrame.offset().left;
              const fT = $gfFrame.offset().top;

              const offset = $that.offset();

              let left = offset.left + fL + targetWidth / 2 - editorWidth / 4;
              let top = offset.top + fT - fST + targetHeight + 8;

              left = left * window._zoomOut;
              top = top * window._zoomOut;

              $quickLink
                .css({
                  left: left,
                  top: top,
                })
                .addClass('show');

              $quickLink
                .find('span.cancel-link')
                .off('click')
                .on('click', function (e) {
                  e.preventDefault();
                  $that.removeClass('editor_link_selection');
                  $quickLink.removeClass('show');
                  $quickLink.find('span.cancel-link');
                  $activeElement.find('.text-editing').off('click.closeQuickLink');
                });

              $quickLink
                .find('span.remove-link')
                .off('click')
                .on('click', function (e) {
                  e.preventDefault();
                  // History
                  if ($gryffEditor.data('gfhistory') && $activeElement && $activeElement.attr('id') != undefined) {
                    $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'));
                  }

                  $that.removeClass('editor_link_selection');
                  $quickLink.removeClass('show');
                  $quickLink.find('span.remove-link');
                  $that.replaceWith($that.html());
                  $activeElement.find('.text-editing').off('click.closeQuickLink');
                  const $itemContent = $activeElement.closest('.item-content');
                  HELPER.detectContentChange($itemContent);
                });

              $quickLink
                .find('span.edit-link')
                .off('click')
                .on('click', function (e) {
                  e.preventDefault();
                  $that.removeClass('editor_link_selection');

                  $quickLink.find('span.edit-link');
                  $quickLink.removeClass('show');
                  _isEditLink = true;
                  $editorTool.find('a[data-action="formatLink"]').click();
                });

              // Event click body close
              $activeElement
                .find('.text-editing')
                .off('click.closeQuickLink')
                .on('click.closeQuickLink', function (e) {
                  if ($(e.target).closest('.editor_link_selection').length == 0) {
                    _this.hideEditorLink();
                    _this.hideQuickLink();
                  }
                });

              const _iframeContent = $gfFrame.contents();
              $(_iframeContent)
                .off('scroll.toolQuickLink')
                .on('scroll.toolQuickLink', function (e) {
                  _this.hideQuickLink();
                  $(_iframeContent).off('scroll.toolQuickLink');
                });
            });
        }
      }
    };

    this.hideEditor = function () {
      if ($editorTool != undefined) {
        $editorTool.removeClass('show');
      }
      setTimeout(function () {
        $gryffBody.find('.text-edit').removeClass('text-editing');

        const _iframeContent = $gfFrame.contents();
        $(_iframeContent).off('scroll.tool');
        _this.hideEditorLink();
        _this.hideQuickLink();

        _isEditing = false;
      }, 0);

      _this.clearSelection();

      return false;
    };

    this.hideEditorLink = function () {
      $editorToolLink.removeClass('show');

      const $aEditing = $gryffBody.find('a.editor_link_selection');
      if ($aEditing) {
        $aEditing.removeClass('editor_link_selection');
        const link_fake = 'https://gem-3910432.net';

        if ($aEditing.attr('href') == link_fake) {
          $aEditing.replaceWith($aEditing.html());
        }
      }
    };

    this.hideQuickLink = function () {
      $quickLink.removeClass('show');
      const $aEditing = $gryffBody.find('a.editor_link_selection');
      if ($aEditing) {
        $aEditing.removeClass('editor_link_selection');
      }
    };

    this.onFocus = function ($target) {
      $activeElement = $target.closest('[data-label="Text Block"], [data-label="Heading"]');
      _this.showEditor($target);
    };

    this.applyEvents = function () {
      const onMouseDown = function (e, typeClick) {
        const $target = jQuery(e.target);
        if ($target.closest('[data-label="Text Block"], [data-label="Heading"]').length > 0) {
          const $text = $target.closest('[data-label="Text Block"], [data-label="Heading"]');

          if ($target.closest('#md-text-editor, .gf-tool-wrap, .editor_link_selection').length == 0) {
            $activeElement = $text;
            _this.saveSelection();
            _this.showEditor($activeElement);
          }

          if ($text.length > 0) {
            setTimeout(function () {
              if ($text.data('gfelement') == undefined) {
                atom.Init($text);
              }
              // $text.data("gfelement").openElementSettings();
            }, 100);
          }
        } else {
          _this.hideEditor();
        }

        // hide editor events
        jQuery('body')
          .off('mousedown.editorB')
          .on('mousedown.editorB', function (eBody) {
            const $target = jQuery(eBody.target);
            if (
              $target.closest(
                '[data-label="Text Block"], [data-label="Heading"], #md-text-editor,#md-editor-link,#gf-pick-link,#md-link-picker,#md-editor-quick-link, .gf-tool-wrap',
              ).length == 0
            ) {
              _this.hideEditor();
              jQuery('body').off('mousedown.editorB');
            }
          });
        $gfLeftSideBar.off('mouseover.editorL').on('mouseover.editorL', function () {
          _this.hideEditor();
          $gfLeftSideBar.off('mouseover.editorL');
        });

        return false;
      };

      // for Tabs Module
      $gryffBody.off('click.editor').on('click.editor', function (e) {
        if (e.which != 3) {
          onMouseDown(e, 'sglclick');
        }
      });

      let typingTimer;
      $element
        .on('keydown.editor', function (e) {
          clearTimeout(typingTimer);
          const $target = jQuery(e.target);

          if (_cacheContent == null) {
            // Cache content để sử dụng cho history;
            _cacheContent = $target.html();
          }

          // ===== GemMeter Feature ===== //
          if ($activeElement.attr('id')) {
            debounce(() => {
              handleElementAttrChanged(`${$activeElement.attr('id').substring(2)}`, 'title-length');
            })();
          }
          // =========================== //

          if ($target.closest('[data-label="Text Block"], [data-label="Heading"]').length > 0) {
            // hide tools
            setTimeout(function () {
              if (
                !$gfFrame.contents().data('gfShortcut') ||
                !$gfFrame.contents().data('gfShortcut').hasKeyPressed('Ctrl')
              ) {
                // _this.hideEditor();
                if (
                  $activeElement != undefined &&
                  $activeElement.data('gfelement') &&
                  $activeElement.data('gfelement').hideTool
                ) {
                  $activeElement.data('gfelement').hideTool();
                }
              } else {
                //convert b to strong
                if (e.originalEvent.code == 'KeyB') {
                  const node = _this.getSelectedNode();
                  if (node != undefined) {
                    const $node = jQuery(node);
                    $node[0].outerHTML = $node[0].outerHTML.replace(/<b>/g, '<strong>').replace(/<\/b>/g, '</strong>');
                  }
                }

                _this.showEditor($target.closest('[data-label="Text Block"], [data-label="Heading"]'));
              }
            }, 10);
          }
        })
        .on('keyup.editor', function (e) {
          clearTimeout(typingTimer);
          typingTimer = setTimeout(function () {
            // detect element or module change
            if ($activeElement != undefined) {
              // History
              if ($gryffEditor.data('gfhistory') && $activeElement && $activeElement.attr('id') != undefined) {
                const extra = {
                  cacheHtml: _cacheContent,
                };
                $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'), extra);
              }

              HELPER.flagListItemChange($activeElement, 'replace');

              const $itemContent = $activeElement.closest('.item-content');
              HELPER.detectContentChange($itemContent);
            }
            _cacheContent = null;
          }, 500);
        });

      //show tab color,highlight;
      $editorTool.find('#md-editor-color .gfTextEditor-tabs span').on('click', function () {
        const $that = $(this);
        if (!$that.hasClass('active')) {
          $editorTool.find('#md-editor-color .gfTextEditor-tabs span').removeClass('active');
          $that.addClass('active');

          const dataAction = $that.attr('data-action');
          $editorTool.find('#md-editor-color .gfTextEditor-tab').removeClass('tab_show');
          $editorTool.find('#md-editor-color .gfTextEditor-tab[data-tab="' + dataAction + '"]').addClass('tab_show');
        }
      });

      /* --- ACTIONS --- */
      $editorTool
        .find('>ul >li >a,>ul .more a')
        .off('click.open')
        .on('click.open', function (e) {
          e.preventDefault();
          const $button = jQuery(this);
          const $subPanel = $button.next('.md-editor-panel');
          if ($subPanel.hasClass('active') || $editorToolLink.hasClass('show')) {
            $subPanel.removeClass('active top bottom');
            $editorToolLink.removeClass('show');
          } else {
            $editorTool.find('.md-editor-panel').removeClass('active top bottom');
            _this.hideEditorLink();
            _this.hideQuickLink();

            // show sub panels
            const position = jQuery(this).offset();
            const top = position.top;
            let _left;
            _left = -($button.next('.md-editor-panel').width() / 2 - $button.width() / 2);

            if (top + $button.next('.md-editor-panel').height() > $(window).height()) {
              $subPanel.addClass('top');
              $subPanel.css({
                top: -1 * ($subPanel.height() + 10),
                left: _left,
              });
            } else {
              $subPanel.addClass('bottom');
              $subPanel.css({
                top: $editorTool.height() + 10,
                left: _left,
              });
            }

            $subPanel.addClass('active');

            var node = _this.getSelectedNode();
            var $node = jQuery(node);

            const type = $button.attr('data-action');
            switch (type) {
              case 'more':
                var widthOld = $editorTool.width();
                $editorTool.find('.gfTextEditor_more').hide();
                $editorTool.find('ul .more').addClass('show_more');
                var widthNew = $editorTool.width();
                $editorTool.css({
                  left: $editorTool.offset().left - (widthNew - widthOld) / 2,
                });
                if ($activeElement != undefined) {
                  HELPER.flagListItemChange($activeElement, 'replace');

                  var $itemContent = $activeElement.closest('.item-content');
                  HELPER.detectContentChange($itemContent);
                }
                return false;
              case 'less':
                var widthOld = $editorTool.width();
                $editorTool.find('.gfTextEditor_more').show();
                $editorTool.find('ul .more').removeClass('show_more');
                var widthNew = $editorTool.width();
                $editorTool.css({
                  left: $editorTool.offset().left + (widthOld - widthNew) / 2,
                });
                if ($activeElement != undefined) {
                  HELPER.flagListItemChange($activeElement, 'replace');

                  var $itemContent = $activeElement.closest('.item-content');
                  HELPER.detectContentChange($itemContent);
                }
                return false;

              case 'plus':
              case 'minus':
                const hasCustomClass = $activeElement.find('.gf_gs_ct');
                const linkedPresetId = app.$store.state['sidebar']['linkedPresetId'];
                if (linkedPresetId > 0 && hasCustomClass.length <= 0) return;

                if ($activeElement.data('gfelement') != undefined) {
                  // History
                  $gryffEditor.data('gfhistory').addHistory('setting', $activeElement.attr('id'));
                  $gryffEditor.data('gfhistory').captureMERSettings();

                  const $self = $activeElement.find('.text-edit');
                  let targetClass = $activeElement.data('gfelement').getTargetClass();

                  let $heading = $self.children('h1,h2,h3,h4,h5,h6');
                  if ($heading.length > 0) {
                    switch ($heading.prop('tagName').toLowerCase()) {
                      case 'h1':
                        targetClass += ' h1';
                        break;

                      case 'h2':
                        targetClass += ' h2';
                        break;

                      case 'h3':
                        targetClass += ' h3';
                        break;

                      case 'h4':
                        targetClass += ' h4';
                        break;

                      case 'h5':
                        targetClass += ' h5';
                        break;

                      case 'h6':
                        targetClass += ' h6';
                        break;
                    }
                  } else {
                    $heading = $self;
                  }

                  var style = $activeElement.data('gfelement').getElementCSS();
                  const screenType =
                    $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

                  let fontSize = HELPER.getValueFromCSS($activeElement, style, 'font-size', screenType, targetClass);
                  if (fontSize == '') {
                    fontSize = parseFloat($heading.css('font-size'));
                  }
                  const lineHeight = $gfLeftSideBar
                    .find('#md-settings')
                    .find('input[name="line-height"]')
                    .attr('value');

                  // adjust fontsize
                  if (type == 'plus') {
                    fontSize = parseFloat(fontSize) + 2;
                  } else if (type == 'minus') {
                    fontSize = parseFloat(fontSize) - 2;
                    if (fontSize < 6) {
                      fontSize = 6;
                    }
                  }
                  fontSize += 'px';

                  const deOptions = [
                    {
                      key: 'font-size',
                      value: fontSize,
                    },
                    {
                      key: 'line-height',
                      value: lineHeight,
                    },
                  ];
                  style = HELPER.designOptions2Style($activeElement, screenType, style, deOptions, targetClass);
                  $activeElement.data('gfelement').setElementCSS(style);

                  // update settings
                  $gfLeftSideBar
                    .find('#md-settings')
                    .find('input[name="font-size"]')
                    .attr('value', fontSize)
                    .val(fontSize)
                    .trigger('value-change');
                  debounce(() => {
                    handleElementAttrChanged(`${$activeElement.attr('id').substring(2)}`, 'font-size');
                  })();

                  clearTimeout(window._gTimeOut);
                  window._gTimeOut = setTimeout(function () {
                    if ($activeElement != undefined) {
                      HELPER.flagListItemChange($activeElement, 'replace');

                      const $itemContent = $activeElement.closest('.item-content');
                      HELPER.detectContentChange($itemContent);
                    }
                  }, 100);
                }
                break;
              case 'formatStyle':
                if (node != undefined) {
                  // History
                  if ($gryffEditor.data('gfhistory') && $activeElement && $activeElement.attr('id') != undefined) {
                    $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'));
                  }

                  // Cache scroll top;
                  const oldScroll = $gfFrame.contents().scrollTop();

                  var s = $button.attr('data-cmd');
                  document.getElementById('gfFrame').contentWindow.document.execCommand(s, false, null);

                  //convert b to strong
                  if (s == 'bold') {
                    var node = _this.getSelectedNode();
                    if (node != undefined) {
                      var $node = jQuery(node);
                      $node[0].outerHTML = $node[0].outerHTML
                        .replace(/<b>/g, '<strong>')
                        .replace(/<\/b>/g, '</strong>');
                    }
                  }

                  $button.toggleClass('active');

                  // Restore scroll
                  $gfFrame.contents().scrollTop(oldScroll);

                  ///detect element or module change
                  if ($activeElement != undefined) {
                    HELPER.flagListItemChange($activeElement, 'replace');

                    var $itemContent = $activeElement.closest('.item-content');
                    HELPER.detectContentChange($itemContent);
                  }
                  return false;
                }
                break;
              case 'formatColor':
                $editorTool.find('#md-editor-color .gfTextEditor-tabs span[data-action="color"]').click();
                if ($node != undefined && $node.attr('style')) {
                  var style = $node.attr('style');
                  const arrayStyle = style.split(';');

                  for (let i = 0; i < arrayStyle.length; i++) {
                    if (arrayStyle[i].indexOf('background-color') >= 0) {
                      var _color = HELPER.rgb2hex(arrayStyle[i].split(':').pop());
                      $subPanel
                        .find('.gryff-color[name="hightlight"]')
                        .attr('value', _color)
                        .val(_color)
                        .trigger('value-change');
                    } else if (arrayStyle[i].indexOf('color') >= 0) {
                      var _color = HELPER.rgb2hex(arrayStyle[i].split(':').pop());
                      $subPanel
                        .find('.gryff-color[name="color"]')
                        .attr('value', _color)
                        .val(_color)
                        .trigger('value-change');
                    } else if ($node.attr('color')) {
                      var color = $node.attr('color');
                      $subPanel
                        .find('.gryff-color[name="color"]')
                        .attr('value', color)
                        .val(color)
                        .trigger('value-change');
                    }
                  }
                } else if ($node != undefined && $node.attr('color')) {
                  var color = $node.attr('color');
                  $subPanel.find('.gryff-color[name="color"]').attr('value', color).val(color).trigger('value-change');
                } else {
                  var color = $node.css('color');
                  if (color) {
                    $subPanel
                      .find('.gryff-color[name="color"]')
                      .attr('value', color)
                      .val(color)
                      .trigger('value-change');
                  } else {
                    $subPanel
                      .find('.gryff-color[name="color"]')
                      .attr('value', 'none')
                      .val('none')
                      .trigger('value-change');
                  }
                }
                if ($node != undefined && !$node.attr('style')) {
                  $subPanel
                    .find('.gryff-color[name="hightlight"]')
                    .attr('value', 'transparent')
                    .val('transparent')
                    .trigger('value-change');
                }

                $subPanel.find('.gryff-color[name="color"]').gfColorPicker({
                  onSelected: function (value) {
                    if (node != undefined) {
                      const color = HELPER.rgb2hex(value);
                      $editorTool.find('a[data-action="formatColor"] .colorActive').css({
                        fill: color,
                      });
                      const gfFrameDocument = document.getElementById('gfFrame').contentWindow.document;

                      if (checkKeyValid('gfTextStyleWithCss')) {
                        gfFrameDocument.execCommand('styleWithCSS', false, true);
                        gfFrameDocument.execCommand('foreColor', false, color);
                      } else {
                        gfFrameDocument.execCommand('foreColor', false, color);
                      }

                      if ($activeElement != undefined) {
                        HELPER.flagListItemChange($activeElement, 'replace');

                        const $itemContent = $activeElement.closest('.item-content');
                        HELPER.detectContentChange($itemContent);
                      }
                    }
                  },
                });
                $subPanel.find('.gryff-color[name="hightlight"]').gfColorPicker({
                  onSelected: function (value) {
                    if (node != undefined) {
                      const color = HELPER.rgb2hex(value);
                      document
                        .getElementById('gfFrame')
                        .contentWindow.document.execCommand('HiliteColor', false, color);
                      if ($activeElement != undefined) {
                        HELPER.flagListItemChange($activeElement, 'replace');

                        const $itemContent = $activeElement.closest('.item-content');
                        HELPER.detectContentChange($itemContent);
                      }
                    }
                  },
                });

                // Close poup color picker
                if ($node != undefined) {
                  const cacheHtml = $activeElement.find('.text-edit').html();
                  const extra = {
                    cacheHtml: cacheHtml,
                  };
                  $gryffEditor.off('click.textcolor').on('click.textcolor', function (e) {
                    const $target = jQuery(e.target);
                    if ($target.closest('#md-editor-color').length == 0) {
                      // History
                      if ($gryffEditor.data('gfhistory') && $activeElement && $activeElement.attr('id') != undefined) {
                        $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'), extra);
                      }
                      $gryffEditor.off('click.textcolor');
                      jQuery('body').off('click.textcolor');
                    }
                  });
                  jQuery('body')
                    .off('click.textcolor')
                    .on('click.textcolor', function (e) {
                      const $target = jQuery(e.target);
                      if ($target.closest('#md-editor-color').length == 0) {
                        // History
                        if (
                          $gryffEditor.data('gfhistory') &&
                          $activeElement &&
                          $activeElement.attr('id') != undefined
                        ) {
                          $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'), extra);
                        }
                        $gryffEditor.off('click.textcolor');
                        jQuery('body').off('click.textcolor');
                      }
                    });
                }

                if ($activeElement != undefined) {
                  HELPER.flagListItemChange($activeElement, 'replace');

                  var $itemContent = $activeElement.closest('.item-content');
                  HELPER.detectContentChange($itemContent);
                }
                return false;

              case 'formatLink':
                var _selectLink = _this.restoreSelection();

                if ($node.prop('tagName').toLowerCase() !== 'a' && !_isEditing) {
                  if (_selectLink.end - _selectLink.start == 0) {
                    return false;
                  }
                } else {
                  _isEditing = false;
                  _this.hideQuickLink();
                }
                $editorToolLink.find('.gfTextEditor_pick_link input').val('');

                var $activeLink;
                var _target;
                var $dom;
                var link_fake = 'https://gem-3910432.net';

                if ($node.prop('tagName').toLowerCase() == 'a') {
                  $activeLink = $node;
                } else {
                  $node.parentsUntil('.element-wrap').each(function () {
                    if (jQuery(this).prop('tagName').toLowerCase() == 'a') {
                      $activeLink = jQuery(this);
                    }
                  });
                }

                if ($divContentHidden.find('#md-editor-link').length == 0) {
                  $divContentHidden.append($editorToolLink);
                }
                $editorToolLink.removeClass('show');

                if (!$activeLink) {
                  document.getElementById('gfFrame').contentWindow.document.execCommand('createLink', false, link_fake);
                  $dom = $($activeElement).find('a[href="' + link_fake + '"]');
                } else {
                  $dom = $activeLink;
                }

                $dom.addClass('editor_link_selection');

                // Calculate left and top;
                setTimeout(function () {
                  const offsetDom = $dom.offset();

                  const targetWidth = $dom.width();
                  const targetHeight = $dom.height();
                  const editorHeight = $editorToolLink.height();
                  const editorWidth = $editorToolLink.width();

                  const fST = $gfFrame.contents().scrollTop();
                  const fL = $gfFrame.offset().left;
                  const fT = $gfFrame.offset().top;

                  const offset = $dom.offset();

                  const $textEditing = $activeElement.find('.text-editing');
                  const offsetText = $textEditing.offset();

                  let left = offset.left + fL + targetWidth / 2 - editorWidth / 4;
                  let top = offset.top + fT - fST + targetHeight + 8;

                  left = left * window._zoomOut;
                  top = top * window._zoomOut;

                  if (left < offsetText.left + fL) {
                    // Left nhỏ hơn text
                    left = offsetText.left + fL - 8;
                  } else if (left + editorWidth > offsetText.left + fL + $textEditing.width()) {
                    // vượt quá text;
                    left = offsetText.left + fL + $textEditing.width() - editorWidth;
                  }

                  $editorToolLink
                    .css({
                      left: left,
                      top: top,
                    })
                    .addClass('show');

                  const _iframeContent = $gfFrame.contents();
                  $(_iframeContent)
                    .off('scroll.toolLink')
                    .on('scroll.toolLink', function (e) {
                      _this.hideEditorLink();
                      $(_iframeContent).off('scroll.toolLink');
                    });
                }, 100);

                // Setup value init
                if ($dom.attr('href') !== link_fake) {
                  $editorToolLink
                    .find('.gfTextEditor_pick_link input')
                    .val($dom.attr('href'))
                    .attr('data-target', $dom.attr('target'));
                }
                $editorToolLink.find('.gfTextEditor_pick_link input').focus();
                // Event click body close
                $activeElement
                  .find('.text-editing')
                  .off('click.closeLink')
                  .on('click.closeLink', function (e) {
                    if ($(e.target).closest('.editor_link_selection').length == 0) {
                      _this.hideEditorLink();
                      $activeElement.find('.text-editing').off('click.closeLink');
                    }
                  });
                // key enter;
                $editorToolLink
                  .find('.gfTextEditor_pick_link input')
                  .off('keyup paste')
                  .on('keyup paste', function (e) {
                    if (e.which == 13) {
                      // History
                      if ($gryffEditor.data('gfhistory') && $activeElement && $activeElement.attr('id') != undefined) {
                        $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'));
                      }

                      $editorToolLink.removeClass('show');
                      const href = $editorToolLink.find('.gfTextEditor_pick_link input').val();
                      if (href !== '') {
                        $button.addClass('active');
                        $dom.attr('href', href);
                      } else {
                        $button.removeClass('active');
                        $dom.replaceWith($dom.html());
                      }
                      $activeElement.find('.text-editing').off('click.closeLink');
                      $dom.removeClass('editor_link_selection');

                      _this.eventLink();

                      if ($activeElement != undefined) {
                        HELPER.flagListItemChange($activeElement, 'replace');

                        const $itemContent = $activeElement.closest('.item-content');
                        HELPER.detectContentChange($itemContent);
                      }
                    }
                  });

                // Click enter save and close
                $editorToolLink
                  .find('.gfTextEditor_pick_link button[data-action="enter"]')
                  .off('click.closePanel')
                  .on('click.closePanel', function () {
                    // History
                    if ($gryffEditor.data('gfhistory') && $activeElement && $activeElement.attr('id') != undefined) {
                      $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'));
                    }

                    $editorToolLink.removeClass('show');
                    const href = $editorToolLink.find('.gfTextEditor_pick_link input').val();
                    if (href !== '') {
                      $button.addClass('active');
                      $dom.attr('href', href);
                    } else {
                      $button.removeClass('active');
                      $dom.replaceWith($dom.html());
                    }
                    $activeElement.find('.text-editing').off('click.closeLink');
                    $dom.removeClass('editor_link_selection');

                    _this.eventLink();

                    if ($activeElement != undefined) {
                      HELPER.flagListItemChange($activeElement, 'replace');

                      const $itemContent = $activeElement.closest('.item-content');
                      HELPER.detectContentChange($itemContent);
                    }
                  });

                $editorToolLink
                  .find('.gfTextEditor_pick_link button[data-action="settings"]')
                  .off('mousedown.adv')
                  .on('mousedown.adv', function (e) {
                    if ($activeElement.find('.openLinkPicker').length > 0) {
                      $activeElement.find('.openLinkPicker').remove();
                    }
                    const $linkPicker = jQuery('<input class="openLinkPicker" style="display:none"/>');

                    $editorToolLink.removeClass('show');
                    $activeElement.append($linkPicker);

                    // Setup value init;
                    const _valueInit = $editorToolLink.find('.gfTextEditor_pick_link input').val();
                    const _target = $editorToolLink.find('.gfTextEditor_pick_link input').attr('data-target');
                    $linkPicker.attr('value', _valueInit).val(_valueInit).attr('data-target', _target);
                    $linkPicker.gfLinkPicker({
                      detectChange: function () {
                        // History
                        if (
                          $gryffEditor.data('gfhistory') &&
                          $activeElement &&
                          $activeElement.attr('id') != undefined
                        ) {
                          $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'));
                        }

                        const href = $linkPicker.attr('value');
                        const target = $linkPicker.data('gflinkpicker').getTarget();

                        if (href !== '') {
                          $dom.attr('href', href).attr('target', target);
                          $button.addClass('active');
                        } else {
                          $dom.replaceWith($dom.html());
                          $button.removeClass('active');
                        }

                        $linkPicker.next('#gf-pick-link').remove();
                        $linkPicker.remove();

                        setTimeout(function () {
                          _this.hideEditorLink();
                        }, 100);

                        // Show editor
                        if ($editorTool != undefined) {
                          $editorTool.addClass('show');
                        }

                        _this.eventLink();

                        if ($activeElement != undefined) {
                          HELPER.flagListItemChange($activeElement, 'replace');

                          const $itemContent = $activeElement.closest('.item-content');
                          HELPER.detectContentChange($itemContent);
                        }
                      },
                    });

                    $linkPicker.next('#gf-pick-link').hide();
                    $linkPicker.next('#gf-pick-link').click();

                    // Set target init;
                    $linkPicker.data('gflinkpicker').setTarget(_target);
                    // Hide Editor not clear select
                    if ($editorTool != undefined) {
                      $editorTool.removeClass('show');
                    }
                  });

                return false;

              case 'formatList':
                if (node !== undefined) {
                  // History
                  if ($gryffEditor.data('gfhistory') && $activeElement && $activeElement.attr('id') != undefined) {
                    $gryffEditor.data('gfhistory').addHistory('text-edit', $activeElement.attr('id'));
                  }
                  if ($button.hasClass('active')) {
                    $button.removeClass('active');
                  } else {
                    $editorTool.find('.formatList').removeClass('active');
                    $button.addClass('active');
                  }
                  var s = $button.attr('data-cmd');

                  document.getElementById('gfFrame').contentWindow.document.execCommand('selectAll', false, null);
                  document.getElementById('gfFrame').contentWindow.document.execCommand(s, false, null);
                }
                if ($activeElement != undefined) {
                  HELPER.flagListItemChange($activeElement, 'replace');

                  var $itemContent = $activeElement.closest('.item-content');
                  HELPER.detectContentChange($itemContent);
                }
                return false;

              default:
                break;
            }

            _this.restoreSelection();
          }

          return false;
        });

      // Show tools tips;
      $editorTool
        .find('>ul >li >a,>ul .more a')
        .off('mouseover.tt')
        .on('mouseover.tt', function (e) {
          e.preventDefault();
          const $button = jQuery(this);
          if ($button.attr('data-toolTips')) {
            $button.gfTooltips({
              delay: 0,
            });
            $button.data('gftooltips').show($button, $button.attr('data-toolTips'));
          }
          return false;
        });
    };

    this.selectAllText = function (target) {
      setTimeout(function () {
        let range, selection;
        if (document.body.createTextRange) {
          range = document.body.createTextRange();

          range.moveToElementText(target);
          range.select();
        } else if (document.getElementById('gfFrame').contentWindow.getSelection) {
          selection = document.getElementById('gfFrame').contentWindow.getSelection();
          range = document.getElementById('gfFrame').contentWindow.document.createRange();
          range.selectNodeContents(target);
          selection.removeAllRanges();
          selection.addRange(range);
        }

        _this.saveSelection();
      }, 0);
      return false;
    };

    this.getSelectedNode = function () {
      let node, selection;
      const frame = document.getElementById('gfFrame');
      const frameWindow = frame && frame.contentWindow;
      const frameDocument = frameWindow && frameWindow.document;
      if (frameDocument) {
        if (frameDocument.getSelection) {
          selection = frameDocument.getSelection();

          if (typeof selection.createRange !== 'function' && selection.rangeCount == 0) {
            return;
          }
          var range = selection.rangeCount > 0 ? selection.getRangeAt(0) : selection.createRange();
          node = range.commonAncestorContainer
            ? range.commonAncestorContainer
            : range.parentElement
            ? range.parentElement()
            : range.item(0);
        } else if (frameDocument.selection) {
          selection = frameDocument.selection;
          var range = selection.rangeCount > 0 ? selection.getRangeAt(0) : selection.createRange();
          node = range.commonAncestorContainer
            ? range.commonAncestorContainer
            : range.parentElement
            ? range.parentElement()
            : range.item(0);
        } else if (frameWindow.getSelection) {
          selection = frameWindow.getSelection();
          node = selection.anchorNode;
        }
      }
      if (node) {
        return node.nodeName == '#text' ? node.parentNode : node;
      }
    };
    this.clearSelection = function () {
      _saveSelection.start = 0;
      _saveSelection.end = 0;
    };
    this.saveSelection = function () {
      _this.clearSelection();
      if ($activeElement != undefined) {
        const containerEl = $activeElement.find('.text-edit')[0];

        if (window.getSelection && document.createRange) {
          var doc = containerEl.ownerDocument,
            win = doc.defaultView;
          const selection = win.getSelection();

          if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const preSelectionRange = range.cloneRange();
            preSelectionRange.selectNodeContents(containerEl);
            preSelectionRange.setEnd(range.startContainer, range.startOffset);
            var start = preSelectionRange.toString().length;

            _saveSelection.start = start;
            _saveSelection.end = start + range.toString().length;
          }
        } else if (document.selection) {
          var doc = containerEl.ownerDocument,
            win = doc.defaultView || doc.parentWindow;
          const selectedTextRange = doc.selection.createRange();
          const preSelectionTextRange = doc.body.createTextRange();
          preSelectionTextRange.moveToElementText(containerEl);
          preSelectionTextRange.setEndPoint('EndToStart', selectedTextRange);
          var start = preSelectionTextRange.text.length;

          _saveSelection.start = start;
          _saveSelection.end = start + selectedTextRange.text.length;
        }
      }

      return _saveSelection;
    };
    this.restoreSelection = function () {
      if ($activeElement != undefined) {
        const containerEl = $activeElement.find('.text-edit')[0];
        const savedSel = _saveSelection;

        if (window.getSelection && document.createRange) {
          const doc = containerEl.ownerDocument,
            win = doc.defaultView;

          let charIndex = 0,
            range = doc.createRange();
          range.setStart(containerEl, 0);
          range.collapse(true);
          let nodeStack = [containerEl],
            node,
            foundStart = false,
            stop = false;

          while (!stop && (node = nodeStack.pop())) {
            if (node.nodeType == 3) {
              const nextCharIndex = charIndex + node.length;
              if (!foundStart && savedSel.start >= charIndex && savedSel.start <= nextCharIndex) {
                range.setStart(node, savedSel.start - charIndex);
                foundStart = true;
              }
              if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex) {
                range.setEnd(node, savedSel.end - charIndex);
                stop = true;
              }
              charIndex = nextCharIndex;
            } else {
              let i = node.childNodes.length;
              while (i--) {
                nodeStack.push(node.childNodes[i]);
              }
            }
          }
          const sel = win.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
        return savedSel;
      }
    };
    this.isEditing = function ($target) {
      if ($target != undefined) {
        return $target.find('.text-edit').hasClass('text-editing');
      } else {
        return _isEditing;
      }
    };
    this.getActiveElement = function () {
      return $activeElement;
    };
    this.makeClass = function () {
      const a = '0123456789';
      const b = 'abcdefghijklmnopqrstuvwxyz';
      return 'font-' + b.charAt(Math.floor(Math.random() * b.length)) + a.charAt(Math.floor(Math.random() * a.length));
    };

    this.init();
  };
  jQuery.fn.gfTextEditor = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gftexteditor')) {
        const plugin = new jQuery.gfTextEditor(this, options);
        jQuery(this).data('gftexteditor', plugin);
      }
    });
  };
})(jQuery);
